import { AiSparkleIcon, AddMiniIcon } from '@calendly/ui/components/icons'
import {
  colorBeachyBlue,
  primaryColorL2,
  textColorL1,
  colorTextStandard,
  colorBackgroundStandard,
  colorBackgroundMeetingIntelligence,
  colorSurfaceActionMeetingIntelligence,
  colorStrokeMeetingIntelligence,
  colorSurfaceAction
} from '@calendly/ui/theme'

import {
  ArrowLeft,
  ArrowLeftMI,
  ArrowRight,
  ArrowRightMI,
  ArrowDown,
  ArrowDownMI,
  ArrowUp,
  ArrowUpMI
} from './assets'

export const THEMES = {
  classic: {
    textColor: colorTextStandard,
    backgroundColor: colorBeachyBlue,
    borderColor: primaryColorL2,
    secondaryButtonColor: textColorL1,
    secondaryButtonIcon: AddMiniIcon,
    primaryButtonColor: primaryColorL2,
    primaryButtonType: 'primary',
    arrowIconSource: {
      right: ArrowLeft,
      left: ArrowRight,
      top: ArrowDown,
      bottom: ArrowUp
    },
    buttonWidth: 'unset',
    maxWidth: '300px',
    textDecoration: 'underline'
  },
  meeting_intelligence: {
    textColor: colorTextStandard,
    backgroundColor: colorBackgroundMeetingIntelligence,
    borderColor: colorStrokeMeetingIntelligence,
    secondaryButtonColor: colorTextStandard,
    primaryButtonColor: colorSurfaceActionMeetingIntelligence,
    primaryButtonType: 'meeting-intelligence',
    primaryButtonIcon: AiSparkleIcon,
    primaryButtonIconColor: colorBackgroundStandard,
    arrowIconSource: {
      right: ArrowLeftMI,
      left: ArrowRightMI,
      top: ArrowDownMI,
      bottom: ArrowUpMI
    },
    buttonWidth: 'auto',
    gap: '0',
    maxWidth: '100%',
    textDecoration: 'none',
    mobileMaxWidth: '100%'
  },
  meeting_intelligence_simplified: {
    textColor: colorTextStandard,
    backgroundColor: colorBackgroundMeetingIntelligence,
    borderColor: colorStrokeMeetingIntelligence,
    secondaryButtonColor: colorTextStandard,
    primaryButtonColor: colorSurfaceActionMeetingIntelligence,
    primaryButtonType: 'meeting-intelligence',
    primaryButtonIconColor: colorBackgroundStandard,
    arrowIconSource: {
      right: ArrowLeftMI,
      left: ArrowRightMI,
      top: ArrowDownMI,
      bottom: ArrowUpMI
    },
    buttonWidth: 'auto',
    maxWidth: '100%',
    textDecoration: 'none',
    bodyTextSize: 'large',
    useTextColor: true,
    isExtended: true,
  },
  meeting_recap_tour: {
    textColor: colorTextStandard,
    backgroundColor: colorBeachyBlue,
    borderColor: '#0069FF80',
    secondaryButtonColor: colorTextStandard,
    primaryButtonColor: colorSurfaceAction,
    primaryButtonType: 'primary',
    primaryButtonIcon: null,
    primaryButtonIconColor: colorBackgroundStandard,
    arrowIconSource: {
      right: ArrowLeft,
      left: ArrowRight,
      top: ArrowDown,
      bottom: ArrowUp
    },
    buttonWidth: 'auto',
    maxWidth: '300px',
    textDecoration: 'none',
  }
}
